import {connect} from 'react-redux';

import {
    showRegisterUser,
    showLogin,
    hideRegisterUser,
    hideLogin,
    logout,
    logoutToAdmin,
    showForgotPassword,
    hideForgotPassword,
    loginUserFromRegister,
} from 'reducers/auth/authActions';

import AuthHeader from './AuthHeader';

const mapStateToProps = (state) => ({
    ...state.auth,
});

const mapDispatchToProps = {
    onShowRegistration: showRegisterUser,
    onShowLogin: showLogin,
    onHideRegistration: hideRegisterUser,
    onHideLogin: hideLogin,
    onLogout: logout,
    onLogoutToAdmin: logoutToAdmin,
    onShowForgotPassword: showForgotPassword,
    onHideForgotPassword: hideForgotPassword,

    onLoginUserFromRegister: loginUserFromRegister,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthHeader);



// WEBPACK FOOTER //
// ./src/components/Auth/AuthHeaderContainer.js